<template>
        <div>
            <CRow>
                <CCol>
                    <div style="width:100%; height: 75vh;">
                        <ejs-grid ref='gridse' :dataSource='spotData' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :allowReordering='true'
                                  :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :pageSettings='pageSettings' :enablePersistence ="true"
                                  :filterSettings='filterOptions' :toolbarClick='toolbarClick' :allowExcelExport='true'
                                  :excelExportComplete='excelExportComplete'  :actionBegin='actionBegin' :actionComplete='actionComplete' :actionFailure="actionFailure" width="100%" height="100%">
                            <e-columns>
                                <e-column  field='id' headerText='' :isPrimaryKey='true' :visible='false'></e-column>
                                <e-column field='name' headerText='Name' :validationRules="requiredRules" width=120></e-column>
                                <e-column field='stateId' headerText='Country' :validationRules="requiredRules" :visible="false" width=120 :edit='stateParams' foreignKeyField='stateId' foreignKeyValue='stateName' :dataSource='state' editType='dropdownedit'></e-column>
                                <e-column field='stateName' headerText='Country' textAlign='Left' width=180 type="string"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </CCol>
            </CRow>
        </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions';
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let dpState, elState
    export default {
        name: 'SpotExchange',
        data() {
            return {
                store: store,
                spotData: SyncHelper.getDataManager("spotExchange"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.SpotExchanges.Update"],
                    allowAdding: store.state.permissions["Permissions.SpotExchanges.Create"],
                    allowDeleting: store.state.permissions["Permissions.SpotExchanges.Delete"],
                    mode: 'Dialog'
                },
                requiredRules: { required: true },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                
                state: SyncHelper.getDataManager("utils/states"),
                stateParams: {
                    create: () => {
                        elState = document.createElement('input');
                        return elState;
                    },
                    read: () => {
                        return dpState.value;
                    },
                    destroy: () => {
                        dpState.destroy();
                    },
                    write: (args) => {
                        dpState = new DropDownList({
                            dataSource: this.state,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Country',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });
                        dpState.appendTo(elState);
                    }
                },
                filterOptions: gridOptions.filterSettings,
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "SpotExchange.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridse.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    this.$refs.gridse.getColumns()[2].visible = true;
                    this.$refs.gridse.getColumns()[3].visible = false;
                   
                }
                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["name"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
             
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>